// src/components/Toggle.js
import React, { useContext } from 'react';
import Switch from 'react-switch';
import { ToggleContext } from '../../contexts/ToggleContext';

const Toggle = ({ id, label, className }) => {
    const { toggles, toggle } = useContext(ToggleContext);
    const isChecked = toggles[id] ?? true;

    const baseClasses = "flex items-center text-gray-800";
    const combinedClasses = `${baseClasses} ${className}`;


    return (
        <div className={combinedClasses}>
            <Switch
                onChange={() => toggle(id)}
                checked={isChecked}
                offColor="#767577"
                onColor="#D52227"
                handleDiameter={20}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={12}
                width={32}
                className={"react-switch"}
            />
            <span className="ml-2 text-white font-semibold">{label}</span>
        </div>
    );
};

export default Toggle;
